'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.waitingStatus = exports.notAvailableStatus = exports.defaultMaxSize = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Placeholder = require('./Placeholder');

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _NotAvailablePlaceholder = require('./NotAvailablePlaceholder');

var _NotAvailablePlaceholder2 = _interopRequireDefault(_NotAvailablePlaceholder);

var _WaitingPlaceholder = require('./WaitingPlaceholder');

var _WaitingPlaceholder2 = _interopRequireDefault(_WaitingPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultMaxSize = exports.defaultMaxSize = 120;
var notAvailableStatus = exports.notAvailableStatus = 'not-available';
var waitingStatus = exports.waitingStatus = 'waiting';

var Thumbnail = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Thumbnail, _Component);

  function Thumbnail() {
    var _ref;

    (0, _classCallCheck3.default)(this, Thumbnail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Thumbnail.__proto__ || (0, _getPrototypeOf2.default)(Thumbnail)).call.apply(_ref, [this].concat(args)));

    _this.state = {
      drawComplete: false
    };
    return _this;
  }

  (0, _createClass3.default)(Thumbnail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.uploader.methods.drawThumbnail(this.props.id, this.canvas, this.props.maxSize).then(function () {
        return _this2.setState({ drawComplete: true, success: true });
      }, function () {
        return _this2.setState({ drawComplete: true, success: false });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('canvas', { ref: function ref(el) {
            return _this3.canvas = el;
          }, hidden: !this.state.drawComplete || this._failure }),
        this._maybePlaceholder
      );
    }
  }, {
    key: '_failure',
    get: function get() {
      return this.state.drawComplete && !this.state.success;
    }
  }, {
    key: '_maybePlaceholder',
    get: function get() {
      if (this._failure) {
        var notAvailableImage = _react2.default.createElement(_NotAvailablePlaceholder2.default, { maxSize: this.props.maxSize });
        return _react2.default.createElement(_Placeholder2.default, { image: notAvailableImage, size: this.props.maxSize, status: notAvailableStatus });
      } else if (!this.state.drawComplete) {
        var waitingImage = _react2.default.createElement(_WaitingPlaceholder2.default, { maxSize: this.props.maxSize });
        return _react2.default.createElement(_Placeholder2.default, { image: waitingImage, size: this.props.maxSize, status: waitingStatus });
      }
      return _react2.default.createElement('span', null);
    }
  }]);
  return Thumbnail;
}(_react.Component), _class.propTypes = {
  id: _propTypes2.default.number.isRequired,
  maxSize: _propTypes2.default.number,
  uploader: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
  maxSize: defaultMaxSize
}, _temp);
exports.default = Thumbnail;


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/Thumb/index.js
// module id = 2000
// module chunks = 1